import Accordion from "./lib/accordion";
import memberNav from "./lib/memberNav";
import SmoothScroll from "smooth-scroll";
import Splide from "@splidejs/splide";

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if (toggle.href == "#") {
      return 0;
    } else {
      const headerHeight = document.querySelector(".header")
        ? document.querySelector(".header").offsetHeight
        : 0;
      return headerHeight;
    }
  },
});

const faq = new Accordion(".js-faq__trigger", {
  speed: 400,
  target: "next",
  event: "click",
  display: "block",
});

memberNav();
